var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0436 16.3906L5.00687 10.0595C4.92904 9.5841 5.52972 9.26148 5.95928 9.54781L9.50653 11.9106C9.78093 12.0934 10.1701 12.0343 10.3617 11.7802L13.4968 7.62729C13.7373 7.30914 14.2606 7.31228 14.4956 7.63356L17.5839 11.847C17.777 12.1104 18.1796 12.1696 18.456 11.9751L22.0282 9.46312C22.4577 9.16111 23.0774 9.48821 22.992 9.9726L21.859 16.3906H6.0436Z",
    fill: "#FCD34D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.3906H22V20.4753C22 20.9808 21.6323 21.3906 21.1787 21.3906H6.82133C6.36775 21.3906 6 20.9808 6 20.4753V18.3906Z",
    fill: "#FCD34D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown1);
export default __webpack_public_path__ + "static/media/crown_1.12a62e8fdde553cd48c8a8a9c0e5adc3.svg";
export { ForwardRef as ReactComponent };